import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { OdontoTherapyViewModel } from 'src/app/model/odonto/therapy.view';
import { ODONTO_MODULE_CONSTANTS } from '../../odonto.constants';

@Component({
  selector: 'ms-odonto-therapy',
  templateUrl: './odonto.therapy.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OdontoTherapyComponent,
      multi: true,
    },
  ],
})
export class OdontoTherapyComponent extends BaseValueAccessor<OdontoTherapyViewModel> {
  readonly screen = ODONTO_MODULE_CONSTANTS;
  @Input() turn = -1;
  @Input() readonly = false;
  @Input() therapies: OdontoTherapyViewModel[] = [];
  today = new Date();
}
